import React from 'react'
import Grid from '@material-ui/core/Grid'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Checkbox from '@material-ui/core/Checkbox'
import { createStyles, withStyles } from '@material-ui/core/styles'
import { Role } from 'types'
import TableHead from 'components/shared/Table/TableHead'
import ReadIcon from 'components/shared/ReadIcon'
import Battery from 'components/shared/Battery'
import { normaliseID, toTitleCase, dateString, getTankLevelColour } from 'utils/common'
import { TRACKERTYPES, MOVABLETYPES } from 'utils/constants'

const columns = [
  { id: 'deviceID', label: 'Device ID', sortable: true },
  { id: '', label: '', sortable: false },
  { id: 'tankId', label: 'Tank ID', sortable: true, role: Role.ADMIN },
  { id: 'type', label: 'Type', sortable: true },
  { id: 'product', label: 'Product', sortable: true },
  { id: 'sh', label: 'Account', sortable: true },
  { id: 'name', label: 'Name', sortable: true },
  { id: 'suburb', label: 'Suburb', sortable: true },
  { id: 'area', label: 'Area', sortable: true, role: Role.CLT },
  { id: 'level', label: 'Level', sortable: true },
  { id: 'pastlevel', label: '48 Hrs Ago', sortable: true, role: Role.CLT },
  { id: 'pastdatetime', label: '48 Hrs Ago TimeStamp', sortable: true, role: Role.CLT },
  { id: 'delivery', label: 'Next Delivery', sortable: true, role: Role.CLT },
  { id: 'status', label: 'Status', sortable: false, role: Role.ADMIN },
  { id: 'updated', label: 'Last Update', sortable: true },
  { id: 'edisetup', label: 'EDI', sortable: true }
]

// Columns for No Of days display - Movable asset
const columns2 = [
  { id: 'deviceID', label: 'Device ID', sortable: true },
  { id: '', label: '', sortable: false },
  { id: 'tankId', label: 'Tank ID', sortable: true, role: Role.ADMIN },
  { id: 'type', label: 'Type', sortable: true },
  { id: 'product', label: 'Product', sortable: true },
  { id: 'sh', label: 'Account', sortable: true },
  { id: 'name', label: 'Name', sortable: true },
  { id: 'suburb', label: 'Suburb', sortable: true },
  { id: 'area', label: 'Area', sortable: true, role: Role.CLT },
  { id: 'level', label: 'Level', sortable: true },
  { id: 'pastlevel', label: '48 Hrs Ago', sortable: true, role: Role.CLT },
  { id: 'pastdatetime', label: '48 Hrs Ago TimeStamp', sortable: true, role: Role.CLT },
  { id: 'delivery', label: 'Next Delivery', sortable: true, role: Role.CLT },
  { id: 'status', label: 'Status', sortable: false, role: Role.ADMIN },
  { id: 'updated', label: 'Last Update', sortable: true },
  { id: 'noofdays', label: '#Days', sortable: true, type: MOVABLETYPES },
  { id: 'edisetup', label: 'EDI', sortable: true }
]

//sorting
const desc = (tankA, tankB, orderBy: string): number => {
  let valueA: string | number
  let valueB: string | number
  switch (orderBy) {
    case 'noofdays':
      valueA = tankA.info.assetnoofdays || ''
      valueB = tankB.info.assetnoofdays || ''
      break
    case 'level':
      valueA = tankA.info.value
      valueB = tankB.info.value
      break
    case 'pastlevel':
      valueA = tankA.info.valuepast
      valueB = tankB.info.valuepast
      break
    case 'updated':
      valueA = tankA.info.lastUpdatedDashBoard || ''
      valueB = tankB.info.lastUpdatedDashBoard || ''
      break
    case 'pastdatetime':
      valueA = tankA.pastLevelDatetime || ''
      valueB = tankB.pastLevelDatetime || ''
      break
    case 'sh':
      valueA = normaliseID(tankA[orderBy] || '')
      valueB = normaliseID(tankB[orderBy] || '')
      break
    default:
      valueA = tankA[orderBy] || ''
      valueB = tankB[orderBy] || ''
  }

  if (valueB < valueA) {
    return -1
  }
  if (valueB > valueA) {
    return 1
  }
  return 0
}

const stableSort = (array, cmp) => {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

const getSorting = (order, orderBy) => {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy)
}

const styles = createStyles({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  tableRow: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
})

interface Props {
  userRole: Role
  classes: any
  tanks: any
  onTankClick: (tankId: string) => void
  typeSelected: any
}

interface State {
  order: string
  orderBy: any
}

class LargeScreen extends React.PureComponent<Props, State> {

  state = {
    order: localStorage.getItem('order'),
    orderBy: localStorage.getItem('orderBy')
  }

  private displayableColumns = columns.filter(column => {
    if (column.role) {
      if (this.props.userRole === column.role) {
        return true
      } else {
        return false
      }
    }
    return true
  })

  private displayableColumns2 = columns2.filter(column2 => {
    if (column2.role) {
      if (this.props.userRole === column2.role) {
        return true
      } else {
        return false
      }
    }
    return true
  })

  // Sorting
  private handleRequestSort = (event, property): void => {
    const orderBy = property
    let order = 'desc'
    localStorage.setItem('order', 'desc');
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc'
       localStorage.setItem('order', 'asc');
       
    }
    this.setState({ order, orderBy })
    localStorage.setItem('orderBy', orderBy);
  }

  public render(): React.ReactNode {
    const { classes, tanks, onTankClick, userRole } = this.props
    const { order, orderBy } = this.state
    // const order= localStorage.getItem('order');
    // const orderBy=localStorage.getItem('orderBy');
    var typeArray = [];
    typeArray = this.props.typeSelected.toString().split(',');
    const found = MOVABLETYPES.some(r => typeArray.indexOf(r) >= 0)
    if (found) {
      return (
        <Paper className={classes.root}>
          <Table className={classes.table} padding="none">
            <TableHead
              columns={this.displayableColumns2}
              onRequestSort={this.handleRequestSort}
              order={order}
              orderBy={orderBy}
            />
            <TableBody>
              {stableSort(tanks, getSorting(order, orderBy)).map(tank => (
                <TableRow
                  className={classes.tableRow}
                  key={tank.deviceID}
                  hover
                  onClick={() => onTankClick(tank.deviceID)}
                >
                  <TableCell align="left">{normaliseID(tank.deviceID)}</TableCell>
                  <TableCell align="left">
                    <ReadIcon tank={tank} hideNormalStatus={true} />
                  </TableCell>
                  {userRole === Role.ADMIN && (
                    <TableCell align="left">{normaliseID(tank.tankId)}</TableCell>
                  )}
                  <TableCell align="left">{tank.type === 'blereader' ? 'BLE Reader' : toTitleCase(tank.type)}</TableCell>
                  <TableCell align="left">{toTitleCase(tank.product)}</TableCell>
                  <TableCell align="left">{normaliseID(tank.sh)}</TableCell>
                  <TableCell align="left">{tank.name}</TableCell>
                  <TableCell align="left">{toTitleCase(tank.suburb)}</TableCell>
                  {userRole === Role.CLT && <TableCell align="left">TBD</TableCell>}
                  {TRACKERTYPES.includes(tank.type) ? (<TableCell>
                  </TableCell>) :
                    (<TableCell
                      align="left"
                      style={{
                        color: getTankLevelColour(tank.info.value),
                      }}
                    >
                      {(tank.zone === 'unassigned' || tank.zone === 'wip') ? `${Math.round(tank.info.value * 100)}%` : (tank.info.value > 200 ? 'Invalid' : tank.info.value < 0 ? '0%' : `${Math.round(tank.info.value * 100)}%`)}
                    </TableCell>)}

                  {userRole === Role.CLT && <TableCell align="left" style={tank.pastLevelDatetime != undefined ? (((new Date().getTime() - 48 * 60 * 60 * 1000) - tank.pastLevelDatetime) / 1000 / 60 / 60 > 6 ? { color: 'rgb(226, 0, 21)' } : { color: 'rgb(49, 203, 70)' }) : { color: 'balck ' }}
                  >{(tank.info.valuepast == undefined ? 'N/A' : `${Math.round(tank.info.valuepast * 100)}%`) || (tank.info.valuepast > 200 ? 'Invalid' : `${Math.round(tank.info.valuepast * 100)}%`)}
                  </TableCell>}
                  {userRole === Role.CLT && <TableCell align="left">
                    {tank.pastLevelDatetime ? dateString(tank.pastLevelDatetime, true) : 'N/A'}
                  </TableCell>}
                  {userRole === Role.CLT && <TableCell align="left">TBD</TableCell>}
                  {userRole === Role.ADMIN && (
                    <TableCell align="left">
                      <Grid container direction="row" justify="flex-start">
                        {tank.type != 'pack' && (<Grid item xs={6}>
                          <Battery main tank={tank} />
                        </Grid>)}
                        <Grid item xs={6}>
                          <Battery tank={tank} />
                        </Grid>
                      </Grid>
                    </TableCell>
                  )}
                  {(tank.statusmovedatetime != undefined && tank.status == 'nos') ?
                    (<TableCell align="left" title={'Moved on\n' + dateString(tank.statusmovedatetime, true)}>
                      {tank.info.lastUpdatedDashBoard && dateString(tank.info.lastUpdatedDashBoard, true)}
                    </TableCell>) :
                    (<TableCell align="left">
                      {tank.info.lastUpdatedDashBoard && dateString(tank.info.lastUpdatedDashBoard, true)}
                    </TableCell>)}
                  <TableCell align="center">{tank.info.assetnoofdays}</TableCell>
                  {tank.type == 'tracker' ? (<TableCell align="left">

                  </TableCell>) : (<TableCell align="left" title='Automatic reordering enabled when checkbox is ticked'>
                    <Checkbox disabled checked={tank.edisetup} />
                  </TableCell>)}
                </TableRow>
              ))}

            </TableBody>
          </Table>
        </Paper>
      )
    }
    else {
      return (
        <Paper className={classes.root}>
          <Table className={classes.table} padding="none">
            <TableHead
              columns={this.displayableColumns}
              onRequestSort={this.handleRequestSort}
              order={order}
              orderBy={orderBy}
            />
            <TableBody>
              {stableSort(tanks, getSorting(order, orderBy)).map(tank => (
                <TableRow
                  className={classes.tableRow}
                  key={tank.deviceID}
                  hover
                  onClick={() => onTankClick(tank.deviceID)}
                >
                  <TableCell align="left">{normaliseID(tank.deviceID)}</TableCell>
                  <TableCell align="left">
                    <ReadIcon tank={tank} hideNormalStatus={true} />
                  </TableCell>
                  {userRole === Role.ADMIN && (
                    <TableCell align="left">{normaliseID(tank.tankId)}</TableCell>
                  )}
                  <TableCell align="left">{tank.type === 'blereader' ? 'BLE Reader' : toTitleCase(tank.type)}</TableCell>
                  <TableCell align="left">{toTitleCase(tank.product)}</TableCell>
                  <TableCell align="left">{normaliseID(tank.sh)}</TableCell>
                  <TableCell align="left">{tank.name}</TableCell>
                  <TableCell align="left">{toTitleCase(tank.suburb)}</TableCell>
                  {userRole === Role.CLT && <TableCell align="left">TBD</TableCell>}
                  {TRACKERTYPES.includes(tank.type) ? (<TableCell>
                  </TableCell>) :
                    (<TableCell
                      align="left"
                      style={{
                        color: getTankLevelColour(tank.info.value),
                      }}
                    >
                      {(tank.zone === 'unassigned' || tank.zone === 'wip') ? `${Math.round(tank.info.value * 100)}%` : (tank.info.value > 200 ? 'Invalid' : tank.info.value < 0 ? '0%' : `${Math.round(tank.info.value * 100)}%`)}
                    </TableCell>)}
                  {userRole === Role.CLT && <TableCell align="left" style={tank.pastLevelDatetime != undefined ? (((new Date().getTime() - 48 * 60 * 60 * 1000) - tank.pastLevelDatetime) / 1000 / 60 / 60 > 6 ? { color: 'rgb(226, 0, 21)' } : { color: 'rgb(49, 203, 70)' }) : { color: 'balck ' }}
                  >{(tank.info.valuepast == undefined ? 'N/A' : `${Math.round(tank.info.valuepast * 100)}%`) || (tank.info.valuepast > 200 ? 'Invalid' : `${Math.round(tank.info.valuepast * 100)}%`)}
                  </TableCell>}
                  {userRole === Role.CLT && <TableCell align="left">
                    {tank.pastLevelDatetime ? dateString(tank.pastLevelDatetime, true) : 'N/A'}
                  </TableCell>}
                  {userRole === Role.CLT && <TableCell align="left">TBD</TableCell>}
                  {userRole === Role.ADMIN && (
                    <TableCell align="left">
                      <Grid container direction="row" justify="flex-start">
                        {tank.type != 'pack' && (<Grid item xs={6}>
                          <Battery main tank={tank} />
                        </Grid>)}
                        <Grid item xs={6}>
                          <Battery tank={tank} />
                        </Grid>
                      </Grid>
                    </TableCell>
                  )}
                  {(tank.statusmovedatetime != undefined && tank.status == 'nos') ?
                    (<TableCell align="left" title={'Moved on\n' + dateString(tank.statusmovedatetime, true)}>
                      {tank.info.lastUpdatedDashBoard && dateString(tank.info.lastUpdatedDashBoard, true)}
                    </TableCell>) :
                    (<TableCell align="left">
                      {tank.info.lastUpdatedDashBoard && dateString(tank.info.lastUpdatedDashBoard, true)}
                    </TableCell>)}
                  {tank.type == 'tracker' ? (<TableCell align="left">
                  </TableCell>) : (<TableCell align="left" title='Automatic reordering enabled when checkbox is ticked'>
                    <Checkbox disabled checked={tank.edisetup} />
                  </TableCell>)}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )
    }
  }
}
export default withStyles(styles)(LargeScreen)
